import React from 'react';
import {Route, Routes} from 'react-router';
import {Navigate} from 'react-router-dom';
import {AppConfig} from '../AppConfig';


const PagesRoutes = () =>
{
  const PageRoutes = AppConfig.pages.map((page, index) =>
  {
    return (
      <Route path={page.url} element={page.component} key={index} />
    );
  });


  return (
    <>
      <Routes>
        {PageRoutes}
        <Route path="*" element={<Navigate to={AppConfig.defaultRoute} replace={true} />} />
      </Routes>
    </>
  );
};

PagesRoutes.propTypes = {};

export {PagesRoutes};
